// extracted by mini-css-extract-plugin
module.exports = {"employeesDownload":"DownloadCsv__employeesDownload--1qnHK","employeesDownloadBalloon":"DownloadCsv__employeesDownloadBalloon--2xg0-"};